// reducers.js
import { CART_FAILURE, CART_REQUEST, CART_SUCCESS, CART_UPDATE } from '../actions/types';

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CART_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CART_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case CART_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case CART_UPDATE:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    default:
      return state;
  }
};
